import { dataService } from 'App';

export function fetchLastAgreement() {
  return dataService.get(`/agreement/view?last=true`);
}

export function updateAgreement() {
  return dataService.patch(`/agreement/version/update`);
}
